import ExifReader from 'exifreader';

export default function readTags(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = function(e) {
            const tags = ExifReader.load(e.target.result);
            delete tags['MakerNote']
            /*if (tags['Thumbnail'] && tags['Thumbnail'].image) {
                var image = document.getElementById('thumbnail');
                image.classList.remove('hidden');
                image.src = 'data:image/jpg;base64,' + tags['Thumbnail'].base64;
            }*/
            resolve(tags)
        };
        reader.readAsArrayBuffer(file);
    })
}